(function ($) {
  if (typeof $ === "undefined") return;

  $(function () {
    if (typeof $.fn.slick !== "function") {
      console.warn("Slick is not loaded");
      return;
    }

    $(".portfolio").each(function () {
      const $root  = $(this);
      const $track = $root.find(".portfolio__track");
      if (!$track.length) return;

      const $prev = $root.find(".portfolio__prev");
      const $next = $root.find(".portfolio__next");
      const $dots = $root.find(".portfolio__dots");
      const $cur  = $root.find(".portfolio__current");
      const total = $track.children().length;

      function pad2(n) {
        n = n + 1;
        return (n < 10 ? "0" : "") + n;
      }

      function applyState(slick, activeIdx) {
        const count = slick.slideCount;
        const next  = (activeIdx + 1) % count;

        $(slick.$slides).each(function () {
          const $s   = $(this);
          const idx  = parseInt($s.attr("data-slick-index"), 10);
          const real = ((idx % count) + count) % count;

          $s.removeClass("is-full is-small");
          if (real === activeIdx) $s.addClass("is-full");
          else if (real === next) $s.addClass("is-small");
        });
      }

      $track.on("init reInit beforeChange afterChange", function (e, slick, cur, nxt) {
        const count  = slick.slideCount || total || 1;
        const active =
          e.type === "beforeChange"
            ? nxt
            : (typeof cur === "number" ? cur : (slick.currentSlide || 0));

        applyState(slick, active);

        if ($cur.length) {
          const normIndex = ((active % count) + count) % count;
          if (e.type !== "beforeChange") {
            $cur.text(pad2(normIndex));
          }
        }

        if (e.type === "init") $track.addClass("is-ready");
      });

      $track.slick({

        mobileFirst: true,


        slidesToShow: 1,
        centerMode: true,
        centerPadding: '80px',
        arrows: false,


        infinite: (total > 2),
        speed: 600,
        dots: true,
        appendDots: $dots.length ? $dots : undefined,
        prevArrow: $prev.length ? $prev : undefined,
        nextArrow: $next.length ? $next : undefined,
        adaptiveHeight: false,
        waitForAnimate: false,
        swipeToSlide: true,
        cssEase: 'ease',
        accessibility: false,

        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              centerMode: false,
              centerPadding: '0px',
              arrows: true
            }
          }
        ]
      });

      const $modal = $root.find(".portfolio-modal");
      const $mTrack = $modal.find(".portfolio-modal__track");
      const $mPrev  = $modal.find(".portfolio-modal__prev");
      const $mNext  = $modal.find(".portfolio-modal__next");
      const $mDots  = $modal.find(".portfolio-modal__dots");
      let modalInited = false;

      function openModalAt(index) {
        $modal.removeAttr("hidden");
        $("html").addClass("posha-modal-open");

        function isElementVisible($el) {
          if (!$el.length) return false;
          const el = $el[0];
          return el.offsetWidth > 0 && el.offsetHeight > 0;
        }

        function safeSetPosition() {
          if (!$mTrack.length) return false;
          if (!isElementVisible($mTrack)) return false;

          const slickInstance = $mTrack.slick('getSlick');
          if (!slickInstance) return false;

          if (slickInstance.$list && slickInstance.$list.length > 0) {
            try {
              $mTrack.slick("setPosition");
              return true;
            } catch (e) {
              return false;
            }
          }
          return false;
        }

        function safeGoToSlide() {
          if (!$mTrack.length) return;
          if (!isElementVisible($mTrack)) {
            setTimeout(safeGoToSlide, 50);
            return;
          }

          const slickInstance = $mTrack.slick('getSlick');
          if (slickInstance && slickInstance.$slides && slickInstance.$slides.length > 0 && slickInstance.$list && slickInstance.$list.length > 0) {
            try {
              $mTrack.slick("slickGoTo", index, true);
            } catch (e) {
              setTimeout(safeGoToSlide, 50);
            }
          } else if (slickInstance) {
            setTimeout(safeGoToSlide, 50);
          }
        }

        if (!modalInited) {
          requestAnimationFrame(function() {
            if ($mTrack.length && $mTrack.children().length > 0) {
              $mTrack.one("init", function () {
                $mTrack.addClass("is-ready");
                setTimeout(function() {
                  safeGoToSlide();
                }, 100);
              });

              $mTrack.slick({
                infinite: (total > 1),
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 600,
                dots: true,
                appendDots: $mDots.length ? $mDots : undefined,
                prevArrow: $mPrev.length ? $mPrev : undefined,
                nextArrow: $mNext.length ? $mNext : undefined,
                adaptiveHeight: true,
                waitForAnimate: false,
                cssEase: "ease",
                lazyLoad: 'ondemand',
                accessibility: false
              });
              modalInited = true;
            }
          });
        } else {
          requestAnimationFrame(function() {
            setTimeout(function() {
              if (safeSetPosition()) {
                safeGoToSlide();
              } else {
                setTimeout(function() {
                  if (safeSetPosition()) {
                    safeGoToSlide();
                  } else {
                    setTimeout(function() {
                      safeSetPosition();
                      safeGoToSlide();
                    }, 50);
                  }
                }, 50);
              }
            }, 100);
          });
        }
      }

      function closeModal() {
        $modal.attr("hidden", true);
        $("html").removeClass("posha-modal-open");
      }

      $root.on("click", "[data-open-details]", function () {
        const idx = parseInt(this.getAttribute("data-open-details") || "0", 10) || 0;
        openModalAt(idx);
      });

      $root.on("click", "[data-close-modal]", closeModal);

      $(document).on("keydown", function (e) {
        if (e.key === "Escape" && !$modal.is("[hidden]")) closeModal();
      });
    });
  });
})(jQuery);




jQuery(function ($) {
    const $slider = $('.posha-slider');
    if (!$slider.length) return;

    $slider.slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 400,

        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: false,
        accessibility: false,
        responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  },
                }
              ],

    });

    const loadImg = (img) => {
        if (!img || img.dataset.loaded) return;
        const src = img.getAttribute('data-src');
        if (!src) return;
        img.src = src;
        img.dataset.loaded = '1';
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
    };

    const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
            if (!e.isIntersecting) return;
            loadImg(e.target);
            io.unobserve(e.target);
        });
    }, { root: null, rootMargin: '300px' });


    $slider.find('.slick-slide:not(.slick-cloned) img.posha-lazy').each(function () {
        io.observe(this);
    });

    $slider.on('afterChange', function () {
        $slider.find('.slick-current img.posha-lazy, .slick-active img.posha-lazy')
            .each(function(){ loadImg(this); });
    });
});
